import { render } from "./FacilityData.vue?vue&type=template&id=da733dac&scoped=true"
import script from "./FacilityData.vue?vue&type=script&lang=js"
export * from "./FacilityData.vue?vue&type=script&lang=js"

import "./FacilityData.vue?vue&type=style&index=0&id=da733dac&scoped=true&lang=css"

import exportComponent from "/builds/mw/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da733dac"]])

export default __exports__